import { styled } from '@mui/material';
import type { ReactNode } from 'react';

type Props = {
  children: ReactNode;
  'aria-label': string;
  'aria-busy'?: boolean;
  'data-testid'?: string;
};

const List = styled('ul')(({ theme }) => ({
  listStyle: 'none',
  margin: 0,
  padding: 0,
  '& > li + li': {
    borderTop: `1px solid ${theme.palette.divider}`,
  },
}));

/**
 * Navigation list of `TopicListItem` rows separated by hairline dividers: the master column of the
 * topics screen, where picking a topic shows its sub-topics.
 */
export function TopicList(props: Props) {
  return (
    <List
      aria-label={props['aria-label']}
      aria-busy={props['aria-busy']}
      data-testid={props['data-testid'] ?? 'topic-list'}
    >
      {props.children}
    </List>
  );
}

export type { Props as TopicListProps };
